<div class="container mt-2">
    <div class="row mb-2">
        <div class="cover-image">
            <img src="{{ project.pictureAccessLink }}" alt="" />
        </div>
    </div>

    <div class="p-4">
        <div class="row mb-2">
            <div class="p-4 project-name-column grey-background">
                <div class="d-flex">
                    <i class="pi pi-book mt-2 mr-2 icon"></i>
                    <span class="column-title">{{ project.name }}</span>
                </div>
                <div class="col mt-3 font-weight-bold">
                    <div class="row">{{ 'projects.pages.public.startingDate' | translate }} {{ project.startDate }}</div>
                    <div class="row">{{ 'projects.pages.public.endingDate' | translate }} {{ project.endDate }}</div>
                    <div class="row">{{ 'projects.pages.public.projectType' | translate }} {{ project.projectType.label }}</div>
                </div>
            </div>

            <div class="p-4 participants-column grey-background">
                <div class="d-flex">
                    <i class="pi pi-users mt-2 mr-2 icon"></i>
                    <span class="column-title">{{ 'projects.pages.public.participants.title' | translate }}</span>
                </div>
                <div class="font-weight-bold">
                    <div class="col mt-3 font-weight-bold">
                        <div class="row">
                            {{ 'projects.pages.public.participants.projectOwner' | translate }} {{ owner?.firstName }} {{ owner?.lastName }}
                        </div>
                        <div class="row">{{ 'projects.pages.public.participants.Community' | translate }} {{ primaryCommunity?.displayName }}</div>

                        <div class="row mt-3">{{ numberOfParticipant }} {{ 'projects.pages.public.participants.attendees' | translate }}</div>
                        <div class="row d-flex">
                            <ul class="row list-participants">
                                <li *ngFor="let profile of project.attendees | slice : 0 : 3; let i = index">
                                    <app-user-avatar
                                        *ngIf="profile.active"
                                        [firstName]="profile.firstName"
                                        [lastName]="profile.lastName"
                                        [picture]=""
                                        data-dismiss="modal"
                                    ></app-user-avatar>
                                </li>
                            </ul>
                            <div class="ml-3">
                                <a href="{{ project.publicJoinUrl }}">
                                    <large-button
                                        label="{{ 'projects.pages.public.participants.joinProject' | translate }}"
                                        [outlined]="true"
                                    ></large-button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="grey-background p-4 context-column">
                <div class="d-flex">
                    <i class="pi pi-info-circle mt-2 mr-2 icon"></i>
                    <span class="column-title">{{ 'projects.pages.public.context' | translate }}</span>
                </div>
                <quill-view [content]="project.context"></quill-view>
            </div>
        </div>
    </div>
</div>
